import React, { type ReactNode } from 'react';
import { StyleSheet } from 'react-native';

import { Container, theme, useNavbarContainerHeight, useResponsive } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { PageWrapper } from '../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardRedemptionContainer = (props: GiftCardRedemptionContainerProps) => {
  const { currentBreakpoint } = useResponsive();
  const { paddingBottomStyle: navbarPaddingBottomStyle } = useNavbarContainerHeight();
  const isNavbarV2Enabled = useFeatureFlag('CELS-5440-order-navbar-v2-enabled');

  // ─── Derived ───────────────────────────────────────────────────────────────

  const shouldApplyNavbarPadding = isNavbarV2Enabled && currentBreakpoint.isXS;
  const safeAreaViewStyle = shouldApplyNavbarPadding ? navbarPaddingBottomStyle : undefined;

  return (
    <PageWrapper
      safeAreaEdges={['top']}
      safeAreaViewStyle={safeAreaViewStyle}
      withoutFooter={currentBreakpoint.isXS}
    >
      <Container wrapperStyle={styles.outerContainer} style={styles.innerContainer}>
        {props.children}
      </Container>
    </PageWrapper>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
  },
  innerContainer: {
    flex: 1,
    alignItems: 'center',
    paddingTop: theme.spacing['8'],
    paddingBottom: theme.spacing['12'],
    minHeight: 300,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardRedemptionContainerProps = {
  children: ReactNode;
};
